(function () {

  function updateSize(selectEl) {
    const descSize = document.getElementById('desc_size');
    if (!descSize || !selectEl) return;

    const selectedText =
      selectEl.options[selectEl.selectedIndex].text.trim();
      descSize.textContent = selectedText;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const select = document.querySelector('.product-form__single-selector');
    updateSize(select);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('product-form__single-selector')) {
      updateSize(e.target);
    }
  });
})();
// =====================================================
// 🔘 CLICK REMOVE HANDLER
// =====================================================

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.line-item__quantity-remove');
  if (!btn) return;

  // 👉 If it's a normal <a> → let Shopify handle it
  if (btn.tagName === 'A' && !btn.dataset.key) {
    return; // ✅ allow default redirect
  }

  e.preventDefault();

  if (btn.disabled) return;
  btn.disabled = true;

  const data = {
    hash: btn.dataset.hash,
    key: btn.dataset.key
  };

  try {
    await cartUpdate(data);
    await updateMinFee();
    window.location.reload(); 
  } catch (err) {
    console.error(err);
  } finally {
    btn.disabled = false;
  }
});

// =====================================================
// 🛒 CART UPDATE (REMOVE ITEMS)
// =====================================================
const cartUpdate = ({ hash, key }) => {
  const updates = {};
  updates[key] = 0;

  const items = document.querySelectorAll(`[data-item-hash='${hash}']`);
  items.forEach((item) => {
    const itemKey = item.dataset.itemKey;
    if (itemKey) {
      updates[itemKey] = 0;
    }
  });

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
  })
  .then(async (res) => {
    const data = await res.json();

    // ⚠️ Don't break on 422
    if (!res.ok) {
      console.warn('Cart update warning:', data);
    }

    return data;
  });
};


// =====================================================
// ⚙️ MAIN LOGIC (MIN FEE + IMPRINTING)
// =====================================================
const updateMinFee = async () => {

  const minFeePrice = window.cartConfig.minFeePrice;
  const minFeeId = window.cartConfig.minFeeId;
  console.log('97 '+minFeeId);

  const res = await fetch('/cart.js');
  const cart = await res.json();
  const items = cart.items;

  const imprintingMap = {};
  let imprintingProductIds = [];
  let totalImpFee = 0;

  items.forEach(item => {

    if (item?.properties?._imprinting === "Imprinting") {

      const price = Number(item.properties._imprintinPrice || 0);
      const qty = Number(item.properties._imprintinQty || 0);
      const id = Number(item.properties._imprintinId || 0);
      const product_id = Number(item.properties._imprintinproduct_id || 0);

      totalImpFee += price * qty;

      // ✅ GROUPING FIX
      if (id) {
        if (!imprintingMap[id]) imprintingMap[id] = 0;
        imprintingMap[id] += qty;
      }

      if (product_id) {
        imprintingProductIds.push(product_id);
      }
    }
  });

  const imprintingItems = Object.keys(imprintingMap).map(id => ({
    id: Number(id),
    quantity: imprintingMap[id]
  }));

  const lineItemMinFeeAdded = items.find(
    item => String(item.id) === String(minFeeId)
  );

  console.log('139 '+lineItemMinFeeAdded);

  const uniqueProductIds = [...new Set(imprintingProductIds)];

  const matchingCartItems = items.filter(item =>
    uniqueProductIds.includes(Number(item.product_id))
  );

  const matchingKeys = matchingCartItems.map(item => item.key);

  const buildZeroUpdates = (keys) => {
    const obj = {};
    keys.forEach(key => obj[key] = 0);
    return obj;
  };

  // =====================================================
  // 🔴 CASE 1 → LESS THAN MIN FEE
  // =====================================================
  if (totalImpFee > 0 && totalImpFee < minFeePrice) {

    if (matchingKeys.length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: buildZeroUpdates(matchingKeys)
        })
      });
    }

    if (!lineItemMinFeeAdded) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: minFeeId, quantity: 1 }]
        })
      });
    }
  }

  // =====================================================
  // 🟢 CASE 2 → GREATER OR EQUAL
  // =====================================================
  else if (totalImpFee >= minFeePrice) {

    if (lineItemMinFeeAdded) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [lineItemMinFeeAdded.key]: 0 }
        })
      });
    }

    const latestRes = await fetch('/cart.js');
    const latestCart = await latestRes.json();
    const latestItems = latestCart.items;

    const itemsToAdd = [];
    const updates = {};

    imprintingItems.forEach(imprintItem => {

      const existingItem = latestItems.find(
        item => Number(item.id) === Number(imprintItem.id)
      );

      if (!existingItem) {
        itemsToAdd.push(imprintItem);
      } else if (existingItem.quantity !== imprintItem.quantity) {
        updates[existingItem.key] = imprintItem.quantity;
      }
    });

    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }

    if (itemsToAdd.length) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: itemsToAdd
        })
      });
    }
  }
};


// =====================================================
// 🔄 AJAX UI REFRESH (NO RELOAD)
// =====================================================
async function refreshCartUI() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // 🟢 Update cart bubble count
    const bubble = document.querySelector('.header__cart-count');
    if (bubble) {
      bubble.textContent = cart.item_count;
    }

    // 🔄 Refresh cart sections
    const sectionRes = await fetch('/cart?sections=cart-items,cart-footer');
    const data = await sectionRes.json();

    const itemsEl = document.querySelector('#shopify-section-cart-items');
    if (itemsEl && data['cart-items']) {
      itemsEl.innerHTML = data['cart-items'];
    }

    const footerEl = document.querySelector('#shopify-section-cart-footer');
    if (footerEl && data['cart-footer']) {
      footerEl.innerHTML = data['cart-footer'];
    }

  } catch (err) {
    console.error('UI refresh failed:', err);
  }
}

// =====================================================
// ⏳ DELAY HELPER (IMPORTANT)
// =====================================================
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


// =====================================================
// 🚀 INITIAL LOAD FIX
// =====================================================
document.addEventListener('DOMContentLoaded', async () => {

  await updateMinFee();

  // ✅ Wait for Shopify sync
  await delay(300);

  await refreshCartUI();
});

// const updateMinFee = async () => {

//   const minFeePrice = window.cartConfig.minFeePrice;
//   const minFeeId = window.cartConfig.minFeeId;
//   console.log('86 minfee '+ minFeeId);

//   const response = await fetch('/cart.js');
//   const cart = await response.json();
//   const items = cart.items;

//   let imprintingItems = [];
//   let imprintingproductsItems = [];
//   let hasChanged = false;

//   const totalImpFee = items.reduce((acc, item) => {

//     if (item?.properties?._imprinting === "Imprinting") {
//       console.log('9999');

//       const price = Number(item.properties._imprintinPrice);
//       const qty = Number(item.properties._imprintinQty);
//       const id = Number(item.properties._imprintinId || 0);
//       const product_id = Number(item.properties._imprintinproduct_id || 0);
//       console.log(product_id);

//       acc += price * qty;

//       imprintingItems.push({
//         id: id,
//         quantity: qty
//       });

//       imprintingproductsItems.push({
//         product_id: product_id
//       });
//     }

//     return acc;

//   }, 0);

//     console.log('123 ' + JSON.stringify(imprintingItems, null, 2));
//     console.log('125 ' + JSON.stringify(imprintingproductsItems, null, 2));

//   const lineItemMinFeeAdded = items.find(
//     item => String(item.id) === String(minFeeId)
//   );

//   console.log('jj ' + JSON.stringify(lineItemMinFeeAdded, null, 2));

//   const uniqueIds = [
//     ...new Set(imprintingproductsItems.map(item => item.product_id))
//   ];

//   console.log(uniqueIds);
//   const matchingCartItems = items.filter(item =>
//     uniqueIds.includes(Number(item.product_id))
//   );

//   console.log(matchingCartItems);

//   const buildZeroUpdates = (ids) => {
//     const obj = {};
//     ids.forEach(id => {
//       obj[id] = 0;
//     });
//     return obj;
//   };

//   const matchingCartItemIds = matchingCartItems.map(
//     item => Number(item.id)
//   );

//   console.log(matchingCartItemIds);
//   console.log('totalImpFee'+ totalImpFee);
//    console.log('minFeePrice'+ minFeePrice);

//   // =====================================================
//   // 🔴 CASE 1 → Need Min Fee
//   // =====================================================
//   if (totalImpFee > 0 && totalImpFee < minFeePrice) {
//     console.log('156');

//     if (!lineItemMinFeeAdded) {
//       console.log('159');

//       hasChanged = true;

//       if (matchingCartItemIds.length) {
//         await fetch('/cart/update.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             updates: buildZeroUpdates(matchingCartItemIds)
//           })
//         });
//       }

//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [{ id: minFeeId, quantity: 1 }]
//         })
//       });
//     }
//   }

//   // =====================================================
//   // 🟢 CASE 2 → Remove Min Fee
//   // =====================================================
//   else {

//     console.log('163 '+ lineItemMinFeeAdded);

//     if (lineItemMinFeeAdded) {

//       hasChanged = true;

//       // Remove min fee
//       await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           updates: { [minFeeId]: 0 }
//         })
//       });

//       console.log(imprintingItems);
//       // 🔁 SAFE RECHECK BEFORE ADDING IMPRINTING
//       if (imprintingItems.length) {
//         console.log('178');

//         const latestRes = await fetch('/cart.js');
//         const latestCart = await latestRes.json();
//         const latestItems = latestCart.items;

//         const itemsToAdd = [];
//         const updates = {};

//         imprintingItems.forEach(imprintItem => {

//           const existingItem = latestItems.find(
//             item => Number(item.id) === Number(imprintItem.id)
//           );

//           if (!existingItem) {
//             // Not in cart → add
//             itemsToAdd.push(imprintItem);
//           }
//           else if (
//             Number(existingItem.quantity) !== Number(imprintItem.quantity)
//           ) {
//             // Qty mismatch → update
//             updates[imprintItem.id] = imprintItem.quantity;
//           }

//         });

//         if (Object.keys(updates).length) {
//           await fetch('/cart/update.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ updates })
//           });
//         }

//         if (itemsToAdd.length) {
//           await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               items: itemsToAdd
//             })
//           });
//         }
//       }
//     }
//   }

//   // =====================================================
//   // 🔄 Reload Only If Changed
//   // =====================================================
//   if (hasChanged) {
//     //window.location.reload();
//   }

// };

function imprintTotal() {
  return {
    total: 0,
    async loadCart() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      let sum = 0;
      cart.items.forEach(item => {
        if (item.properties?._imprinting === "Imprinting") {
          const price = Number(item.properties._imprintinPrice || 0);
          const qty   = Number(item.properties._imprintinQty || 0);
          sum += price * qty;
        }
      });
      this.total = sum / 100;
    }
  }
}